// extracted by mini-css-extract-plugin
export default {"main":"Fundamentals_main__hzuqw"};